export const environment = {
    production: false,
    name: 'qa',
    apiURL: "https://agnapiqaiot.azurewebsites.net/api/",
    azureAd: {
        clientId: "68ebe0d2-39b8-49bc-b003-dc57d8765e09",
        tenantId: "6f4d03de-9551-4ba1-a25b-dce6f5ab7ace",
        authority: "https://login.microsoftonline.com/abbvie.onmicrosoft.com/",
        redirectUri: "https://bcproductsupportqa.allerganaesthetics.com",
        scopeUri: "api://33d41548-0a42-4912-9547-935e745b2da8/.default",
        postLogoutRedirectUri: "https://bcproductsupportqa.allerganaesthetics.com",
        navigateToLoginRequestUrl: false
    }
};